/**
 * Whether a position from the phone is one to use (InGo ADR 0004: trust the
 * device fix). Nothing here talks to a map provider; this was
 * `googleMapsConfig.js` until 2 Oct 2026, when its Google Maps URL builders
 * left with the Google map.
 */

/**
 * Reject coordinates that are common garbage (NaN, out of range, null island).
 * @param {number} lat
 * @param {number} lng
 * @returns {boolean}
 */
export function isReliableGpsLatLng(lat, lng) {
  const la = Number(lat);
  const lo = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(lo)) return false;
  if (Math.abs(la) > 90 || Math.abs(lo) > 180) return false;
  if (Math.abs(la) < 1e-8 && Math.abs(lo) < 1e-8) return false;
  return true;
}

/** Persisted GPS cache TTL — stale fixes must not pin the map to an old city. */
export const GEO_CACHE_MAX_AGE_MS = 3 * 60 * 60 * 1000;

/**
 * Device GPS we trust for maps / pickup: any real fix.
 *
 * Until 2026-09-03 this required the fix to fall inside a Zimbabwe box, which
 * threw away every fix taken outside Zimbabwe — a driver testing from Kampala
 * saw a map of Harare and was published online with no coordinates, so
 * nothing about proximity could work. Decision (Rio): trust the device.
 * @param {number} lat
 * @param {number} lng
 * @returns {boolean}
 */
export function isAcceptableDeviceFix(lat, lng) {
  return isReliableGpsLatLng(lat, lng);
}
